import Simple from "./Simple";
import useSiteConfig from "@/lib/useSiteConfig";

export function Privacy() {
  const cfg = useSiteConfig();
  const email = cfg.support_email || "stay@vyagram.com";
  return (
    <Simple title="Privacy Policy">
      <p>Vyagram respects your privacy. This page outlines what we collect (contact details, booking information, optional preferences), why we collect it (to host your stay and improve our service), and how it's stored (on secure, India-based infrastructure).</p>
      <p>We do not sell guest data. We share information with payment and booking partners only as required to fulfil your reservation.</p>
      <p>Write to us at <a href={`mailto:${email}`} className="underline">{email}</a> for any privacy request.</p>
    </Simple>
  );
}

export function Terms() {
  return (
    <Simple title="Terms">
      <p>Reservations are subject to our standard booking terms and individual property rules. Payments are processed via verified partners. Cancellations follow the policy shown at the time of booking.</p>
      <p>Damage to the property, loss of keys, and violation of house rules may incur charges as outlined at check-in.</p>
    </Simple>
  );
}

export function HouseRules() {
  return (
    <Simple title="House Rules">
      <p><strong>Quiet hours</strong> are observed across every Vyagram stay out of respect for neighbours and community.</p>
      <p><strong>Gatherings</strong> need prior written approval and are limited to select properties.</p>
      <p><strong>Commercial shoots</strong> require written approval and a shoot fee. Personal content is welcome.</p>
      <p><strong>Smoking</strong> is not allowed indoors. Balconies and terraces where available.</p>
      <p><strong>Pets</strong> on request.</p>
    </Simple>
  );
}
